import { useEffect, useRef, useState } from "react";
import { motion, animate, useInView } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 50, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-100px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ index, children, testId }) => (
  <div
    data-testid={testId}
    className="flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.25em] text-epic-sub mb-10 md:mb-16"
  >
    <span className="text-epic-accent">{index}</span>
    <span className="inline-block w-8 h-px bg-epic-line" />
    {children}
  </div>
);

export const CountUp = ({ value, prefix = "", suffix = "", decimals = 0, label }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState((0).toFixed(decimals));

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration: 1.6,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => setDisplay(v.toFixed(decimals)),
    });
    return () => controls.stop();
  }, [inView, value, decimals]);

  return (
    <span ref={ref}>
      {prefix}
      {display}
      {suffix}
      {label ? ` ${label}` : ""}
    </span>
  );
};
